import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { RouteReuseStrategyService } from '../../services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { TicketsAndGuestsStateService } from 'app/manage-tickets-and-guests/services/tickets-and-guests-tabs.service';

@Component({
  selector: 'app-ticket-guest-list-page',
  templateUrl: './ticket-guest-list-page.component.html',
  styleUrls: ['./ticket-guest-list-page.component.scss']
})
export class TicketGuestListPageComponent implements OnInit, AfterViewInit,OnDestroy {

  private takeUntilSubject: Subject<any> = new Subject();
  private takeUntilRouteReuseStrategySubject: Subject<any> = new Subject();
  public selectedCampaignId;
  constructor(
    private element: ElementRef,
    private route: ActivatedRoute,
    private router: Router,
    private routeReuseStrategyService: RouteReuseStrategyService,
    public ticketsAndGuestStateService: TicketsAndGuestsStateService
  ) {}

  ngOnInit(): void {
    const $ = window['$'];

    this.routeReuseStrategyService.status = true;
    this.routeReuseStrategyService.routeReuseStrategySubject.pipe(
      takeUntil(this.takeUntilRouteReuseStrategySubject)
    ).subscribe(({ future }) => {
      switch(future.fragment) {
        case "":
          $(`#ticketsTabNav`).tab('show');
          break;
        default:
          $(`#${future.fragment}Nav`).tab('show');
      }

      this.takeUntilSubject.next(null);
      this.takeUntilSubject.complete();
      this.takeUntilSubject = new Subject();

      this.ngAfterViewInit();
    });
  }

  ngAfterViewInit(): void {
    const self = this;

    this.route.params.pipe(
      first(),
      takeUntil(this.takeUntilSubject)
    ).subscribe(params => {
      this.selectedCampaignId = this.ticketsAndGuestStateService.selectedCampaignId;
      window['orgMain'].showTicketGuestList({
        id: params.id,
      },1,undefined, this.ticketsAndGuestStateService);
    });

    $(this.element.nativeElement).off("click");
    $(this.element.nativeElement).on("click", "a[role='tab']", function(event) {
      event.preventDefault();
      const fragment = $(this).data('fragment');
      self.router.navigate([], { relativeTo: self.route, fragment });
    });
    
  }

  ngOnDestroy(): void {
    window["$"]('#ticketGuestList').empty()
    window["$"]('#ticketGuestList').hide()

    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  
    this.takeUntilRouteReuseStrategySubject.next(null);
    this.takeUntilRouteReuseStrategySubject.complete();

    this.routeReuseStrategyService.status = false;
  }
}
